import { useEffect, useState } from 'react';
import { FiPlus, FiEdit2, FiTrash2 } from 'react-icons/fi';
import api from '../../api/client';

export default function AdminProfesores() {
    const [profesores, setProfesores] = useState([]);
    const [modal, setModal] = useState(null);
    const [cargando, setCargando] = useState(true);

    const cargar = async () => {
        setCargando(true);
        const r = await api.get('/admin/profesores');
        setProfesores(r.data.profesores || []);
        setCargando(false);
    };
    useEffect(() => { cargar(); }, []);

    const eliminar = async (id) => {
        if (!window.confirm('¿Eliminar profesor?')) return;
        await api.delete(`/admin/profesores/${id}`);
        cargar();
    };

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h1 style={{ margin: 0, fontSize: 24 }}>Profesores</h1>
                <button className="btn btn-primario" onClick={() => setModal({})}>
                    <FiPlus /> Nuevo profesor
                </button>
            </div>

            <table className="tabla">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>Especialidad</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {profesores.map(p => (
                        <tr key={p.id}>
                            <td>{p.nombre}</td>
                            <td>{p.correo}</td>
                            <td>{p.especialidad}</td>
                            <td style={{ display: 'flex', gap: 6 }}>
                                <button className="icon-btn" onClick={() => setModal(p)}><FiEdit2 /></button>
                                <button className="icon-btn" onClick={() => eliminar(p.id)} style={{ color: 'var(--error)' }}><FiTrash2 /></button>
                            </td>
                        </tr>
                    ))}
                    {profesores.length === 0 && (
                        <tr><td colSpan="4" style={{ textAlign: 'center', padding: 24, color: 'var(--texto-suave)' }}>Sin profesores</td></tr>
                    )}
                </tbody>
            </table>

            {modal && <ModalProfesor profesor={modal} cerrar={() => setModal(null)} onGuardado={cargar} />}
        </div>
    );
}

function ModalProfesor({ profesor, cerrar, onGuardado }) {
    const [datos, setDatos] = useState({
        nombre: profesor?.nombre || '',
        correo: profesor?.correo || '',
        especialidad: profesor?.especialidad || '',
        biografia: profesor?.biografia || ''
    });
    const [error, setError] = useState('');

    const guardar = async (e) => {
        e.preventDefault();
        try {
            if (profesor.id) {
                await api.put(`/admin/profesores/${profesor.id}`, datos);
            } else {
                await api.post('/admin/profesores', datos);
            }
            onGuardado();
            cerrar();
        } catch (err) {
            setError(err.response?.data?.error || 'Error');
        }
    };

    return (
        <div className="modal-bg">
            <div className="modal">
                <h2>{profesor.id ? 'Editar' : 'Nuevo'} profesor</h2>
                {error && <div className="error-msg">{error}</div>}
                <form onSubmit={guardar}>
                    <div className="form-group">
                        <label>Nombre completo</label>
                        <input className="input" value={datos.nombre} onChange={e => setDatos({ ...datos, nombre: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Correo</label>
                        <input type="email" className="input" value={datos.correo} onChange={e => setDatos({ ...datos, correo: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Especialidad</label>
                        <input className="input" value={datos.especialidad} onChange={e => setDatos({ ...datos, especialidad: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Biografia</label>
                        <textarea className="input" rows={3} value={datos.biografia} onChange={e => setDatos({ ...datos, biografia: e.target.value })} />
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <button type="button" className="btn btn-fantasma" onClick={cerrar}>Cancelar</button>
                        <button type="submit" className="btn btn-primario">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
